module.exports = __webpack_public_path__ + "img/georgia.75392d9a.svg";